<template>
  <div class="shared-link">
    <h5>SHARE ARTICLE</h5>
    <social-sharing
      url="http://bridgeport.1pls1.com/#/about"
      title="FC Bridgeport United"
      description="Football is a family of team sports that involve, to varying degrees, kicking a ball to score a goal. "
      quote
      hashtags="football,bridgeportunitedfc,sportinghartfordfc"
      twitter-user="FC Bridgeport United"
      inline-template
    >
      <ul class="social-sharing">
        <li>
          <network
            network="facebook"
            class="social-icon"
            :style="{ backgroundImage: 'url(' + require(`@/assets/img/facebook.png`) + ')' }"
          ></network>
        </li>
        <li>
          <network
            network="telegram"
            class="social-icon"
            :style="{ backgroundImage: 'url(' + require(`@/assets/img/telegram.svg`) + ')' }"
          ></network>
        </li>
        <li>
          <network
            network="twitter"
            class="social-icon"
            :style="{ backgroundImage: 'url(' + require(`@/assets/img/twitter.png`) + ')' }"
          ></network>
        </li>
      </ul>
    </social-sharing>
  </div>
</template>
<script>
export default {
  data() {
    return {
      share: [
        {
          network: "facebook",
          img: "img/facebook.png"
        },
        {
          network: "telegram",
          img: "img/telegram.svg"
        },
        {
          network: "twitter",
          img: "img/twitter.png"
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.shared-link {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  padding: 1rem 0;
  h5 {
    font-size: 1.2rem;
    line-height: 2rem;
    color: #363636;
    font-weight: 500;
    text-transform: uppercase;
    margin-top: 2px;
    white-space: nowrap;
    margin-right: 1rem;
    @media only screen and (max-width: 768px) {
      margin-top: 0;
    }
    @media only screen and (max-width: 399px) {
      display: none;
    }
  }
  ul {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    li {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
  }
}
</style>